module.exports = __webpack_public_path__ + "static/services-img3-aa30f43d0c3ae780ff8868a5672c6b76.png";